module.exports = __webpack_public_path__ + "e788bf14fc28eda0d0c134438d5a99de.ttf";